// extracted by mini-css-extract-plugin
export default {"wrapper":"Legend__wrapper--Az4aJ","title":"Legend__title--y93IM","options":"Legend__options--DtGwQ","option":"Legend__option--tEGfI","icon":"Legend__icon--GxWVY"};